define('core/extensions/helpers/geturl',[],function () {
    'use strict';

    // WARNING: Only for development, geturl calls get replaced by grunt-smartrev
    return window.geturl || function (url) {
        return url;
    };
});

